import * as React from "react";
import {Link, PaletteColor, Typography, useTheme} from "@mui/material";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import Stack from "@mui/material/Stack";
import {useTranslate} from "@tolgee/react";

interface NestedCardProps
{
    title: string,
    urls?: string[],
    children: React.ReactNode,
    action?: React.ReactNode,
    headerColor: string,
    headerTextColor: string,
    subtitle?: string
}

export function NestedCard({
    title,
    urls,
    children,
    action,
    headerColor,
    headerTextColor,
    subtitle
}: NestedCardProps) {

    return (<Card raised>
        <CardHeader
            title={
                <Typography variant="body1" color={headerTextColor} sx={{fontWeight: 'bold'}}>
                    {[title,
                        ...((urls?.length ?? 0 > 0) ?
                            [" [", urls?.map((url, index) => (
                                <React.Fragment key={"url" + index}>
                                    <Link href={url} variant="body1" color={headerTextColor}
                                          sx={{fontWeight: 'bold'}} target="_blank">{index + 1}</Link>
                                    {index + 1 < (urls?.length ?? 0) ? ", " : ""}
                                </React.Fragment>
                            )), "]"] : [])
                    ]}
                </Typography>}
            subheader={
                (subtitle
                    ?
                    <Typography variant="body2" color={headerTextColor}>
                        {subtitle}
                    </Typography>
                    :
                    undefined
                )}
            sx={{
                bgcolor: headerColor,
                color: headerTextColor,
                p: 1
            }}
            disableTypography
            action={action ?? <React.Fragment/>}
        />
        <CardContent>
            <Stack spacing={2}>
                {children}
            </Stack>
        </CardContent>
    </Card>);
}